export default __webpack_public_path__ + "static/de-66e74ded6b8f19c335fb7ed104b72d0c.svg";